module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_april7.70cee6263a5bc17da5acf2339d6f073c.png";